import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import userInfoActions from '../actions/userInfo';
import actions from '../actions/actions';

// responds to 'GET_CONFIRMATION_PAGE_INFO' action
// Sources user metadata from Core API/PMX for accurate advertiser snapshot
function getConfirmationPageInfo(store) {
    request.get(`/${config.url_prefix}/api/confirmationPageInfo?site=${store.getState().system.siteName}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(userInfoActions.alertError('ipmob.internal.server.error'));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (!parsedResponse || parsedResponse.code >= 400 || parsedResponse.statusCode >= 400) {
                        store.dispatch(userInfoActions.alertError('ipmob.error.process.request'));
                    } else {
                        store.dispatch(userInfoActions.getUserInfoSuccess(parsedResponse));
                    }
                } catch (exp) {
                    store.dispatch(userInfoActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}
export default getConfirmationPageInfo;
